__turbopack_context__.v({
  "inline": "b8Rn7W_inline",
  "shareBtn": "b8Rn7W_shareBtn",
  "shareBtns": "b8Rn7W_shareBtns",
  "shareBtnsTitle": "b8Rn7W_shareBtnsTitle",
});
